import * as React from "react";
const SvgFiRrPrayingHands = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-praying-hands_svg__a)">
      <path
        fill="#062147"
        d="M23.711 20.296c-.404-.41-.71-.903-.71-1.478v-5.693a9 9 0 0 0-1.75-5.333L16.458 1.28a3 3 0 0 0-4.177-.738c-.103.072-.19.158-.28.24-.093-.082-.18-.17-.282-.24-1.356-.947-3.229-.617-4.164.719L2.75 7.79A9 9 0 0 0 1 13.127v5.693c0 .575-.306 1.069-.71 1.478a1 1 0 0 0 1.418 1.41A4.39 4.39 0 0 0 3 18.588v-5.46A7 7 0 0 1 4.361 8.98l4.82-6.552a1.003 1.003 0 0 1 1.392-.246 1 1 0 0 1 .411.646.98.98 0 0 1-.149.725s-4.263 5.726-4.35 5.865c-.269.378-.485.798-.485 1.444v5.14a1 1 0 1 0 2 0v-5a1 1 0 0 1 2 0v6.5c0 3.358-1.522 4.637-1.61 4.707a1 1 0 0 0 1.21 1.593c.098-.073 2.4-1.851 2.4-6.3 0 4.449 2.302 6.227 2.4 6.3a1 1 0 0 0 .593.198 1 1 0 0 0 .792-.391 1.007 1.007 0 0 0-.173-1.398c-.065-.053-1.61-1.325-1.61-4.71v-6.5a1 1 0 0 1 2 0v5a1 1 0 1 0 2 0v-5.14c0-.65-.22-1.07-.487-1.445-.087-.14-4.333-5.841-4.333-5.841a1 1 0 0 1-.165-.747 1 1 0 0 1 .411-.646 1.01 1.01 0 0 1 1.407.266l4.805 6.53a7 7 0 0 1 1.362 4.15v5.459c0 1.179.46 2.287 1.292 3.12a1 1 0 0 0 1.42-1.41zM14.082 8.144A2.995 2.995 0 0 0 12 10.999a2.99 2.99 0 0 0-2.083-2.855L12 5.337z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-praying-hands_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPrayingHands;
